import assert from './assert';
import * as _ from 'lodash';

export const viewTypes = Object.freeze({
  MOBILE: 'MOBILE',
  DESKTOP: 'DESKTOP',
});

const viewTypeDefinitionsPx = Object.freeze({
  [viewTypes.MOBILE]: 767,
});

const viewDefinitionValues = _.values(viewTypeDefinitionsPx);

assert(
  _.isEqual(viewDefinitionValues, viewDefinitionValues.sort((a: number, b: number) => a - b)),
  'viewTypeDefinitions values must be in ascending order.',
);

export const getViewType = (): string => {
  const keys = Object.keys(viewTypeDefinitionsPx);
  const windowWidth = window.innerWidth;
  for (const viewKey of keys) {
    if (windowWidth <= viewTypeDefinitionsPx[viewKey]) {
      return viewKey;
    }
  }

  return viewTypes.DESKTOP;
};
